import React from "react";
import ContactBanner from "./contactbanner";
import ContactDetails from "./contactdetails";
import Readytostart from "../Products/readytostart";
import { useEffect} from "react";

function ContactUs(){
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(
        <div>
            <ContactBanner />
            <ContactDetails />
            <Readytostart/>
        </div>
    )
}

export default ContactUs;